import { InvoicePreview, useUpcomingInvoice } from '../../../../queries/billing/use-upcoming-invoice';
import { formatDate } from '../../../../utilities/formatting';
import InvoiceTable from './InvoiceTable';

function BillingSection(): JSX.Element {
    const query = useUpcomingInvoice();

    const invoice = query.data?.invoice as InvoicePreview;

    return (
        <div className="flex gap-16 flex-wrap">
            <div className="w-[400px]">
                <h3 className="text-contentPrimary font-bold">Billing</h3>
                <p className="text-sm text-contentSecondary mt-1">
                    See a detailed preview of your upcoming charges, including plans, add-ons, discounts, and tax.
                </p>
            </div>
            <div className="flex-1">
                <p className="text-sm font-bold text-contentPrimary">
                    Next invoice ({invoice ? formatDate(invoice!.periodStart) : ''} - {invoice ? formatDate(invoice!.periodEnd) : ''})
                </p>
                <InvoiceTable isLoading={query.isLoading || query.isFetching} invoice={invoice} />
            </div>
        </div>
    );
}

export default BillingSection;
